/* ============================================================================
   Big Z's home: bottom dock and Saved Fellas (2026-10-22; ZZ: dock "updated to what we currently have",
   Compare out, Saved Fellas stays). Loaded by snippets/bz-d1-home, after assets/bz-d1-home.js.
   Saved Fellas itself (the list, the drawer, what a heart does when tapped) is assets/bz-v4-commerce.js.
   This file only:
     1. marks the dock link for the section on screen (aria-current) in the dock bz-d1-home swaps in,
     2. puts a Saved Fellas heart on each Just Landed card whose product is in the home catalog
        (window.ZDATA: the bugs and habitats collections), matched by handle; the commerce script's
        click handler and sync() run it from there,
     3. copies the Saved Fellas and bag counts into data-count, so a zero badge hides (bz-d1-fixes),
     4. opens Saved Fellas at /#saved-fellas, where the Saved pill on every other page points,
     5. sends "Find your next fella" in the Saved Fellas and bag drawers to Just Landed (the commerce
        script looks for the old finder, which this home cut),
     6. moves the review row on by one card every 5 seconds (ZZ: "Make these auto scroll"). It waits while the
        row is off screen, hovered, focused or touched, starts paused under reduced motion, and the Pause
        button stops it for good,
     7. opens Judge.me's store review form in the Write a review pop-up (ZZ: "give an option to add judgeme
        review"). Judge.me's widget code loads on the first press only; if it has not shown the form within
        8 seconds the button goes to the Judge.me review page instead.
   Styles: snippets/bz-d1-fixes. Markup for 6 and 7: snippets/bz-d1-more.
   ========================================================================== */
(function () {
  'use strict';
  if (window.bzD1Dock) return;
  window.bzD1Dock = true;
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* 1. Dock scrollspy: the section whose top has passed 40% of the screen is current; above the first, none is. */
  var spies = [].slice.call(document.querySelectorAll('.zx-dock a[data-bzd1-spy]')).map(function (a) {
    return { a: a, el: document.getElementById(a.getAttribute('data-bzd1-spy')) };
  }).filter(function (x) { return x.el; });
  var queued = false;
  function spy() {
    queued = false;
    var line = window.innerHeight * 0.4, cur = null;
    spies.forEach(function (x) { if (x.el.getBoundingClientRect().top <= line) cur = x; });
    spies.forEach(function (x) { x.a.setAttribute('aria-current', x === cur ? 'true' : 'false'); });
  }
  if (spies.length) {
    window.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(spy); } }, { passive: true });
    window.addEventListener('resize', spy);
    spy();
  }

  /* 2. Hearts on Just Landed cards. */
  var data = window.ZDATA || {};
  var byHandle = {};
  [].concat(data.products || [], data.habitats || []).forEach(function (p) { if (p && p.handle) byHandle[p.handle] = p; });
  var savedNow = window.ZUI && window.ZUI.getSaved ? window.ZUI.getSaved() : [];
  [].slice.call(document.querySelectorAll('[data-bzd1-card]')).forEach(function (card) {
    var media = card.querySelector('.bzd1-card__media');
    var json = card.querySelector('script[data-bzd1-fella]');
    if (!media || !json || media.querySelector('.bzd1-save')) return;
    var f;
    try { f = JSON.parse(json.textContent); } catch (e) { return; }
    var p = f && f.product && byHandle[f.product.handle];
    if (!p) return;
    var id = String(p.id), on = savedNow.indexOf(id) !== -1, name = f.name || p.name;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'bzd1-save';
    b.setAttribute('data-z-save', id);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', (on ? 'Remove ' + name + ' from' : 'Save ' + name + ' to') + ' Saved Fellas');
    b.innerHTML = HEART;
    media.appendChild(b);
  });

  /* 3. Count badges: data-count follows the number the commerce script writes. */
  function mirror(el) { var n = (el.textContent || '').trim(); if (el.getAttribute('data-count') !== n) el.setAttribute('data-count', n); }
  var badges = [].slice.call(document.querySelectorAll('[data-z-saved-count],[data-z-cart-count]'));
  badges.forEach(mirror);
  if (badges.length && window.MutationObserver) {
    var mo = new MutationObserver(function (records) {
      records.forEach(function (r) {
        var el = r.target.nodeType === 3 ? r.target.parentNode : r.target;
        if (el && el.hasAttribute && (el.hasAttribute('data-z-saved-count') || el.hasAttribute('data-z-cart-count'))) mirror(el);
      });
    });
    badges.forEach(function (el) { mo.observe(el, { childList: true, characterData: true, subtree: true }); });
  }

  /* 4. /#saved-fellas opens Saved Fellas. */
  function openSaved() {
    if (location.hash !== '#saved-fellas' || !window.ZUI || !window.ZUI.saved) return;
    window.ZUI.saved();
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) { }
  }
  openSaved();
  window.addEventListener('hashchange', openSaved);

  /* 5. "Find your next fella" in the drawers lands on Just Landed (or the zone row). */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-z-find-fella]');
    if (!b || document.getElementById('zx-collection')) return;
    var target = document.getElementById('bzd1-landed') || document.getElementById('bzd1-shop');
    if (!target) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var dlg = b.closest('dialog');
    if (dlg && dlg.open) dlg.close();
    target.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
  }, true);

  /* 6. Review row moves on by itself. */
  var row = document.querySelector('.bzd1-qgrid[data-bzd1-auto]');
  var ctl = document.querySelector('[data-bzd1-auto-ctl]');
  var tog = document.querySelector('[data-bzd1-auto-toggle]');
  if (row) {
    var stopped = reduced.matches, hold = false, onScreen = false, resume = null;
    var canMove = function () { return row.scrollWidth > row.clientWidth + 8; };
    var setTog = function () {
      if (!tog) return;
      tog.setAttribute('data-paused', stopped ? 'true' : 'false');
      tog.querySelector('span').textContent = stopped ? 'Play' : 'Pause';
      tog.setAttribute('aria-label', stopped ? 'Play the reviews' : 'Pause the reviews');
    };
    var fit = function () { if (ctl) ctl.hidden = !canMove(); };
    var step = function () {
      if (stopped || hold || !onScreen || document.hidden || !canMove()) return;
      var card = row.firstElementChild;
      if (!card) return;
      var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      var end = row.scrollLeft + row.clientWidth >= row.scrollWidth - 8;
      row.scrollTo({ left: end ? 0 : row.scrollLeft + card.getBoundingClientRect().width + gap, behavior: 'smooth' });
    };
    var pauseFor = function (ms) {
      hold = true;
      clearTimeout(resume);
      if (ms) resume = setTimeout(function () { hold = false; }, ms);
    };
    row.addEventListener('mouseenter', function () { pauseFor(0); });
    row.addEventListener('mouseleave', function () { hold = false; });
    row.addEventListener('focusin', function () { pauseFor(0); });
    row.addEventListener('focusout', function () { hold = false; });
    row.addEventListener('touchstart', function () { pauseFor(0); }, { passive: true });
    row.addEventListener('touchend', function () { pauseFor(8000); }, { passive: true });
    row.addEventListener('wheel', function () { pauseFor(8000); }, { passive: true });
    if (tog) tog.addEventListener('click', function () { stopped = !stopped; setTog(); });
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; }, { threshold: 0.4 }).observe(row);
    } else { onScreen = true; }
    setTog();
    fit();
    window.addEventListener('resize', fit);
    setInterval(step, 5000);
  }

  /* 7. Write a review: Judge.me's store review form, loaded on the first press. */
  var wrBtn = document.querySelector('[data-bzd1-write-review]');
  var wr = document.getElementById('bzd1-wr');
  if (wrBtn && wr) {
    var wrBody = wr.querySelector('[data-bzd1-wr-body]');
    var wrTpl = wr.querySelector('template[data-bzd1-wr-tpl]');
    var wrStarted = false;
    var wrAway = function () { window.location.href = wrBtn.getAttribute('data-fallback') || 'https://judge.me/reviews/stores/www.bigzs.shop'; };
    var wrShow = function () {
      var link = wrBody.querySelector('.jdgm-write-rev-link');
      if (link && !wrBody.classList.contains('is-ready')) { link.click(); wrBody.classList.add('is-ready'); }
      var first = wrBody.querySelector('.jdgm-form textarea, .jdgm-form input:not([type="hidden"])');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { } }
    };
    var wrStart = function () {
      if (wrStarted) return;
      wrStarted = true;
      var j = window.jdgm;
      if (!j || !j.loadScript || !j.CDN_HOST || !wrTpl) { wrAway(); return; }
      wrBody.appendChild(wrTpl.content.cloneNode(true));
      var w = wrBody.querySelector('.jdgm-widget');
      var t0 = Date.now(), kicked = false;
      j.loadScript(j.CDN_HOST + 'shopify_v2.js');
      (function poll() {
        var link = wrBody.querySelector('.jdgm-write-rev-link');
        if (w.classList.contains('jdgm--done-setup-widget') && link) { wrShow(); return; }
        if (!kicked && Date.now() - t0 > 1500 && typeof window.jdgm.initializeWidgets === 'function') {
          kicked = true;
          try { window.jdgm.initializeWidgets(); } catch (e) { }
        }
        if (Date.now() - t0 > 8000) { wrAway(); return; }
        setTimeout(poll, 150);
      })();
    };
    wrBtn.addEventListener('click', function () {
      if (typeof wr.showModal === 'function') { if (!wr.open) wr.showModal(); } else { wrAway(); return; }
      if (wrStarted) wrShow(); else wrStart();
    });
    wr.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-bzd1-wr-close]')) { wr.close(); return; }
      if (e.target !== wr) return;
      var r = wr.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) wr.close();
    });
    wr.addEventListener('close', function () { wrBtn.focus(); });
  }
})();
